<template>
	<div
		class="text paddingSize"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			backgroundColor: data.backgroundColor,
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<!-- 底部文字 -->
		<p
			class="textInfo"
			v-if="data.content"
			:style="{
				color: data.textColor,
				fontSize: data.fontSize + 'px',
				fontWeight: data.fontWeight,
				lineHeight: data.fontLineHeight + 'px',
				textAlign: data.textAlign,
			}"
		>
			{{ data.content }}
		</p>
		<div class="textInfo" v-else>默认文字</div>
	</div>
</template>

<script>
export default {
	name: 'text_component',
	props: ['data'],
};
</script>

<style lang="scss" scoped>
.content_text {
	white-space: pre-line;
}
.textInfo {
	font-size: 12px;
	font-family: PingFang SC;
	font-weight: bold;
	color: #000000;
	line-height: 18px;
	text-align: center;
	letter-spacing: 3px;
	padding: 5px 0;
	white-space: pre-line;
	word-break: break-all;
}
</style>